export default __webpack_public_path__ + "maps-guides-view-annotation-selected-1200-61f856037c175d698e269930fb80ef72.webp";